const TESTIMONIALS = [
  { name: "Sarah Chen", role: "Marketing Director", quote: "QAIRO AI has transformed how we create content. We produce 10x more content with the same team." },
  { name: "Marcus Johnson", role: "Startup Founder", quote: "The image generation is incredible. We've saved thousands on design costs while improving quality." },
  { name: "Emily Rodriguez", role: "Content Manager", quote: "Finally, an AI tool that understands brand voice. Our content has never been more consistent." },
];

export function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-24 px-8 md:px-16 bg-black text-white">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#0066FF] mb-4 text-center">Testimonials</p>
        <h2 className="text-3xl sm:text-4xl tracking-tight font-bold text-center mb-16">Loved by Marketers Worldwide</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {TESTIMONIALS.map((t) => (
            <div
              key={t.name}
              className="border border-white/20 p-8"
              data-testid={`testimonial-${t.name.toLowerCase().replace(/\s/g, "-")}`}
            >
              <p className="text-lg mb-6 leading-relaxed">"{t.quote}"</p>
              <div>
                <p className="font-bold">{t.name}</p>
                <p className="text-sm text-gray-400">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
